import { CategoriesScreen } from '@ui/finance/CategoriesScreen'
import { Voltar } from '@ui/shell/Voltar'

/**
 * As categorias e subcategorias da casa, com casa própria.
 *
 * ## Ela não constrói nada novo, e é isso que a torna barata
 *
 * `CategoriesScreen` já criava com `parentId` (que é o que faz uma
 * subcategoria), renomeava, arquivava e avisava de colisão entre irmãs. O que
 * faltava era **onde ela mora**: dentro de `/cadastros`, empilhada abaixo de
 * contas e cartões, alcançável só por Transações.
 *
 * ## E isto executa o que o router já dizia
 *
 * O comentário de `/cadastros` chama a tela de *"andaime da Fase 2 (…) sai
 * quando a Fase 4 der lugar próprio a cada cadastro"*. É este o lugar próprio
 * de categorias. Contas e cartões continuam lá até terem o deles.
 *
 * ## Empilhada sobre Ajustes, como o contexto de agente
 *
 * `TABS` continua com quatro itens — `Docs/04-Design/Navegação.md`. Daqui se
 * volta para Ajustes, que é de onde se entra.
 */
export function Categorias() {
  return (
    <section>
      <div className="mb-2">
        <Voltar para="/ajustes">Ajustes</Voltar>
      </div>
      {/* O título e a descrição moram na TELA, e não aqui: o botão de criar
          precisa dividir a linha com o `<h1>`, e o dono do botão é quem tem a
          folha. Esta rota é só onde ela é pendurada. */}
      <CategoriesScreen />
    </section>
  )
}
